// extracted by mini-css-extract-plugin
export default {"root":"ColoredText_root__HJK-T","red":"ColoredText_red__9ROu1","grey":"ColoredText_grey__BlIDO","green":"ColoredText_green__RskAj","yellow":"ColoredText_yellow__RexRZ"};